import clsx from 'clsx';
import { FC, PropsWithChildren, useState } from 'react';
import { AiOutlineArrowDown, AiOutlineArrowUp } from 'react-icons/ai';
import { Button } from '../button/Button';
import { AnimatePresence, motion } from 'framer-motion';
import { SectionHeader } from './SectionHeader';
import { IconType } from 'react-icons';

interface Props {
  header: string;
  defaultExpanded?: boolean;
  Icon: IconType;
  error?: boolean;
}

export const CollapsibleSection: FC<PropsWithChildren<Props>> = ({
  header,
  Icon,
  children,
  error = false,
  defaultExpanded = true
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <div>
      <div className="flex justify-between items-center space-x-2">
        <SectionHeader error={error} title={header} Icon={Icon} />
        <Button
          primary={!error}
          secondary={error}
          Icon={isExpanded ? AiOutlineArrowUp : AiOutlineArrowDown}
          onClick={() => setIsExpanded(!isExpanded)}
        />
      </div>
      <AnimatePresence>
        {isExpanded && (
          <motion.div
            className={clsx('pt-4')}
            initial={{ height: 0 }}
            animate={{ height: 'auto' }}
            exit={{ height: 0 }}
            style={{ overflow: 'hidden' }}
          >
            {children}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
